import { useIsAdminUserForBlog } from 'data/blogs/client'
import { useHost } from 'data/hosts'
import { Host } from 'data/hosts/types'
import { isNil } from 'lodash'
import { useEffect } from 'react'
import { getHostOrigin } from 'utilities/url'
// import styles from './InlineAdminAttacher.module.css'

type Props = {
  blogSlug: string,
}

const InlineAdminAttacher = ({ blogSlug }: Props) => {
  const { isAdminUser } = useIsAdminUserForBlog(blogSlug)
  const { host } = useHost(blogSlug)
  useEffect(() => {
    if (host && isAdminUser) {
      // console.log('SEND IS ADMIN')
      setTimeout(() => {
        sendIsAdmin(host, isAdminUser)
      }, 0)
    }
  }, [host, isAdminUser])
  return <></>
  // <div className={styles.inlineAdminAttacher}>
  //   Attach Admin?: { isAdminUser ? 'ADMIN' : 'NERP' } { blogSlug }
  // </div>
}

const sendIsAdmin = (host: Host, isAdminUser: boolean) => {
  if (isNil(host)) {
    // console.log('No host')
    setTimeout(() => {
      sendIsAdmin(host, isAdminUser)
    }, 1000)
  } else {
    const origin = getHostOrigin(host)
    // console.log('send heighT', { isAdmin, host })
    isAdminUser && window?.parent?.postMessage({
      blotter: {
        type: 'setIsAdmin',
        isAdminUser,
      }
    }, origin)
  }
}

export default InlineAdminAttacher
